import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SessionStorageService, SessionStorage } from 'angular-web-storage';
import moment from 'moment';
import { AlertDialogService } from 'src/app/services/alert-dialog.service';
import { ApiService } from 'src/app/services/api.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EmailService } from 'src/app/services/email-service';
import { SessionService } from 'src/app/services/session.service';

interface Participant {
  name: string;
  role: string;
  status: 'Invited' | 'Accepted' | 'Declined';
  isYou?: boolean;
  roleColor?: string;
}

@Component({
  selector: 'app-event-dialog',
  templateUrl: './event-dialog.component.html',
  styleUrls: ['./event-dialog.component.scss']
})
export class EventDialogComponent {
  username : string = '';
  userData: any 
  constructor(
    public dialogRef: MatDialogRef<EventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string;
      subtitle: string;
      date: string;
      time: string;
      duration: string;
      event_attendees: Participant[];
      meetingLink: string;
      description: string;
      createdBy: string;
      invitedBy: string;
      event_log_key:any;
      rawData:any;
      diaplayActions:boolean;
    },
    private sessionService: SessionService,
    private apiService: ApiService,
    private dialogService: DialogService,
    private alertDialogService : AlertDialogService,
    private emailService: EmailService
  ) {this.username = this.sessionService.getUsernameLocal();
    this.userData = this.data.event_attendees.find((participant: any) => participant.email === this.username);

  }

  onAccept(): void {
    
           let postData:any ={
            "event_attendee_status":"accepted",
            "event_attendees_email": this.username,
            "event_log_key": this.data.event_log_key
           }
              this.apiService.updateAttendeesStatus(postData).subscribe(
                (res) => {console.log("Event status updated successfully:", res);});
  }

   onDelete(): void {
    this.alertDialogService.confirmationWindow('Are you sure you want to delete this event?')
      .then((result: any) => {
        if (result) {
          let postData: any = {
            "isEventHost": this.data.createdBy == this.username ? "true" : "false",
            "event_attendees_email": this.username,
            "event_log_key": this.data.event_log_key
          };
  
          // 1. Delete from your backend
          this.apiService.deleteEvent(postData).subscribe(
            (res) => {
              // 2. Delete from Outlook (Graph API)
             const graphEventId = sessionStorage.getItem('graph_id') || this.data.rawData.graph_id;
              if (graphEventId) {
                this.emailService.deleteGraphCalendarEvent(graphEventId)
                  .then(() => {
                    this.dialogService.openSnackBar("Event deleted from Outlook and backend.", "OK");
                  })
                  .catch((err: any) => {
                    console.error("Error deleting Outlook event:", err);
                    this.dialogService.openSnackBar("Event deleted from backend, but failed to delete from Outlook.", "OK");
                  });
              } else {
                this.dialogService.openSnackBar("Event deleted from Outlook.", "OK");
              }
  
              let value = {
                status: 'delete',
                id: this.data.event_log_key
              };
              this.apiService.triggerAction$.next(value);
            },
            (error) => {
              console.error("Error while deleting event:", error);
              this.dialogService.openSnackBar("Error while deleting event..", "OK");
            }
          );
        }
      })
      .catch(() => { });
  }
onEdit(): void {
  // Trigger edit flow in your app
  const value = {
    status: 'edit',
    id: this.data.event_log_key,
    eventData: this.data.rawData
  };
  this.apiService.triggerAction$.next(value);
}


  onReject(): void {
    
    let postData:any ={
      "event_attendee_status":"rejected",
      "event_attendees_email": this.username,
      "event_log_key": this.data.event_log_key
     }
        this.apiService.updateAttendeesStatus(postData).subscribe(
          (res) => {console.log("Event status updated successfully:", res);});
  }
}  